import { useEffect } from 'react';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';

const TwitterCustomRedirect = () => {
  const popupWindowURL = new URL(window.location.href);
    const token = popupWindowURL.searchParams.get("oauth_token");
    const tokenSecret = popupWindowURL.searchParams.get("oauth_verifier");
    const error = popupWindowURL.searchParams.get("error");
    const error_description = popupWindowURL.searchParams.get("error_description");
  const state = popupWindowURL.searchParams.get('state');

  useEffect(() => {
    if (token|| tokenSecret || error) {
      addAccessToken(token,tokenSecret, state);
    }
  }, [token,tokenSecret, error, state]); // include state in dependency array

  const addAccessToken = (token,tokenSecret, state) => {
    const form = {
      token: token,
      token_secret: tokenSecret,
      integration_hash_id: state,
    };

    const postProps = {
      url: userModuleURL.addAccessToken,
      body: form,
      successCallback: (data, message) => {
        if (data?.url) {
          window.location.href = data.url; // redirect to the provided URL
        }
      },
      failureCallback: (errMessage) => {
        console.error('Access token error:', errMessage);
      },
    };

    HttpServices.Post(postProps);
  };

  return null;
};

export default TwitterCustomRedirect;
